import { render, staticRenderFns } from "./Farmacia.vue?vue&type=template&id=3f71ec52&scoped=true"
import script from "./Farmacia.vue?vue&type=script&lang=js"
export * from "./Farmacia.vue?vue&type=script&lang=js"
import style0 from "./Farmacia.vue?vue&type=style&index=0&id=3f71ec52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71ec52",
  null
  
)

export default component.exports